/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AiExplanationResponse } from '../models';
// @ts-ignore
import type { ConsentResponse } from '../models';
// @ts-ignore
import type { DataDeletionRequestDto } from '../models';
// @ts-ignore
import type { DataDeletionResponse } from '../models';
// @ts-ignore
import type { DataExportResponse } from '../models';
// @ts-ignore
import type { DataSubjectRequestDto } from '../models';
// @ts-ignore
import type { DataSubjectRequestResponse } from '../models';
// @ts-ignore
import type { RecordConsentRequest } from '../models';
// @ts-ignore
import type { RecordObjectionRequest } from '../models';
// @ts-ignore
import type { RequiredConsentDto } from '../models';
/**
 * GDPRPrivacyApi - axios parameter creator
 * @export
 */
export const GDPRPrivacyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Accepts the current version of every pending required consent (Terms, Privacy Policy), recording IP address, User-Agent and timestamp. Returns the consents still pending (normally empty).
         * @summary Accept all required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptRequiredConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/consents/required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only while still awaiting confirmation or within the grace period.
         * @summary Cancel my deletion request
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDeletion: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelDeletion', 'id', id)
            const localVarPath = `/api/gdpr/deletion/{id}/cancel`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Public: the token itself is the authenticator, matching the password-reset confirm flow. Starts the grace period before the deletion is actually executed.
         * @summary Confirm a data deletion request via its emailed token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDeletion: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('confirmDeletion', 'token', token)
            const localVarPath = `/api/gdpr/deletion/confirm`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Human review of an automated result (AI_REVIEW), rectification of data the user cannot edit (RECTIFICATION, requires rectificationField), objection (OBJECTION), an explanation of a recommendation (EXPLANATION) or restriction of processing (RESTRICTION). Answered by a person within one month (`dueAt`).
         * @summary File a data-subject request (GDPR Arts. 16, 21, 22)
         * @param {DataSubjectRequestDto} dataSubjectRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest: async (dataSubjectRequestDto: DataSubjectRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataSubjectRequestDto' is not null or undefined
            assertParamExists('createRequest', 'dataSubjectRequestDto', dataSubjectRequestDto)
            const localVarPath = `/api/gdpr/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataSubjectRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * A participant refuses the pending required consents. The refusal is recorded, the participant is told they cannot advance in the programme, and their facilitators and the admins are notified. Returns the consents still pending.
         * @summary Decline the required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineRequiredConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/consents/required/decline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Export my personal data (GDPR Art. 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMyData: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/export/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get my consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/consents/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get my deletion request status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDeletionRequests: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/deletion/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 404 when it does not exist or is about someone else.
         * @summary Get one explanation of a recommendation generated about me
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyExplanation: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMyExplanation', 'id', id)
            const localVarPath = `/api/gdpr/explanations/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Newest first. Each says which categories of my data were used, the logic (prompt and model version) and the reasons and evidence given.
         * @summary List the explanations of recommendations generated about me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyExplanations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/explanations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Terms / Privacy Policy not yet accepted at the version currently in force. Empty when up to date.
         * @summary Get my pending required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingRequiredConsents: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/consents/required`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Explanation id by kind (PLAN_FOCUS, PLAN_DIAGNOSIS, PLAN_BLUEPRINT) of the AI proposal the plan was created from. Empty when the plan was not generated or is not mine.
         * @summary Get the explanation ids behind one of my development plans
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPlanExplanationIds: async (planId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planId' is not null or undefined
            assertParamExists('getMyPlanExplanationIds', 'planId', planId)
            const localVarPath = `/api/gdpr/explanations/plans/{planId}`
                .replace(`{${"planId"}}`, encodeURIComponent(String(planId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List my data-subject requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRequests: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/gdpr/requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record or update a consent
         * @param {RecordConsentRequest} recordConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordConsent: async (recordConsentRequest: RecordConsentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordConsentRequest' is not null or undefined
            assertParamExists('recordConsent', 'recordConsentRequest', recordConsentRequest)
            const localVarPath = `/api/gdpr/consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordConsentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * processing: PROFILE_ASSESSMENT or RESEARCH. Takes effect immediately and is available before the required consents are accepted.
         * @summary Object to, or withdraw the objection to, AI profiling or research (GDPR Art. 21)
         * @param {RecordObjectionRequest} recordObjectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordObjection: async (recordObjectionRequest: RecordObjectionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'recordObjectionRequest' is not null or undefined
            assertParamExists('recordObjection', 'recordObjectionRequest', recordObjectionRequest)
            const localVarPath = `/api/gdpr/objections`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordObjectionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request deletion of my data (GDPR Art. 17)
         * @param {DataDeletionRequestDto} dataDeletionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeletion: async (dataDeletionRequestDto: DataDeletionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'dataDeletionRequestDto' is not null or undefined
            assertParamExists('requestDeletion', 'dataDeletionRequestDto', dataDeletionRequestDto)
            const localVarPath = `/api/gdpr/deletion/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataDeletionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GDPRPrivacyApi - functional programming interface
 * @export
 */
export const GDPRPrivacyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GDPRPrivacyApiAxiosParamCreator(configuration)
    return {
        /**
         * Accepts the current version of every pending required consent (Terms, Privacy Policy), recording IP address, User-Agent and timestamp. Returns the consents still pending (normally empty).
         * @summary Accept all required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptRequiredConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequiredConsentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptRequiredConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.acceptRequiredConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only while still awaiting confirmation or within the grace period.
         * @summary Cancel my deletion request
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelDeletion(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelDeletion(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.cancelDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Public: the token itself is the authenticator, matching the password-reset confirm flow. Starts the grace period before the deletion is actually executed.
         * @summary Confirm a data deletion request via its emailed token
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async confirmDeletion(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.confirmDeletion(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.confirmDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Human review of an automated result (AI_REVIEW), rectification of data the user cannot edit (RECTIFICATION, requires rectificationField), objection (OBJECTION), an explanation of a recommendation (EXPLANATION) or restriction of processing (RESTRICTION). Answered by a person within one month (`dueAt`).
         * @summary File a data-subject request (GDPR Arts. 16, 21, 22)
         * @param {DataSubjectRequestDto} dataSubjectRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRequest(dataSubjectRequestDto: DataSubjectRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataSubjectRequestResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRequest(dataSubjectRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.createRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * A participant refuses the pending required consents. The refusal is recorded, the participant is told they cannot advance in the programme, and their facilitators and the admins are notified. Returns the consents still pending.
         * @summary Decline the required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async declineRequiredConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequiredConsentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.declineRequiredConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.declineRequiredConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Export my personal data (GDPR Art. 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async exportMyData(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataExportResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.exportMyData(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.exportMyData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get my consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConsentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get my deletion request status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyDeletionRequests(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataDeletionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyDeletionRequests(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyDeletionRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 404 when it does not exist or is about someone else.
         * @summary Get one explanation of a recommendation generated about me
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyExplanation(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AiExplanationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyExplanation(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyExplanation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Newest first. Each says which categories of my data were used, the logic (prompt and model version) and the reasons and evidence given.
         * @summary List the explanations of recommendations generated about me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyExplanations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AiExplanationResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyExplanations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyExplanations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Terms / Privacy Policy not yet accepted at the version currently in force. Empty when up to date.
         * @summary Get my pending required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPendingRequiredConsents(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RequiredConsentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPendingRequiredConsents(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyPendingRequiredConsents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Explanation id by kind (PLAN_FOCUS, PLAN_DIAGNOSIS, PLAN_BLUEPRINT) of the AI proposal the plan was created from. Empty when the plan was not generated or is not mine.
         * @summary Get the explanation ids behind one of my development plans
         * @param {number} planId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyPlanExplanationIds(planId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyPlanExplanationIds(planId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyPlanExplanationIds']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List my data-subject requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyRequests(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DataSubjectRequestResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyRequests(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.getMyRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Record or update a consent
         * @param {RecordConsentRequest} recordConsentRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordConsent(recordConsentRequest: RecordConsentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordConsent(recordConsentRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.recordConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * processing: PROFILE_ASSESSMENT or RESEARCH. Takes effect immediately and is available before the required consents are accepted.
         * @summary Object to, or withdraw the objection to, AI profiling or research (GDPR Art. 21)
         * @param {RecordObjectionRequest} recordObjectionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async recordObjection(recordObjectionRequest: RecordObjectionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.recordObjection(recordObjectionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.recordObjection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Request deletion of my data (GDPR Art. 17)
         * @param {DataDeletionRequestDto} dataDeletionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async requestDeletion(dataDeletionRequestDto: DataDeletionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataDeletionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.requestDeletion(dataDeletionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['GDPRPrivacyApi.requestDeletion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * GDPRPrivacyApi - factory interface
 * @export
 */
export const GDPRPrivacyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GDPRPrivacyApiFp(configuration)
    return {
        /**
         * Accepts the current version of every pending required consent (Terms, Privacy Policy), recording IP address, User-Agent and timestamp. Returns the consents still pending (normally empty).
         * @summary Accept all required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptRequiredConsents(options?: RawAxiosRequestConfig): AxiosPromise<Array<RequiredConsentDto>> {
            return localVarFp.acceptRequiredConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * Only while still awaiting confirmation or within the grace period.
         * @summary Cancel my deletion request
         * @param {GDPRPrivacyApiCancelDeletionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelDeletion(requestParameters: GDPRPrivacyApiCancelDeletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataDeletionResponse> {
            return localVarFp.cancelDeletion(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Public: the token itself is the authenticator, matching the password-reset confirm flow. Starts the grace period before the deletion is actually executed.
         * @summary Confirm a data deletion request via its emailed token
         * @param {GDPRPrivacyApiConfirmDeletionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        confirmDeletion(requestParameters: GDPRPrivacyApiConfirmDeletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataDeletionResponse> {
            return localVarFp.confirmDeletion(requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * Human review of an automated result (AI_REVIEW), rectification of data the user cannot edit (RECTIFICATION, requires rectificationField), objection (OBJECTION), an explanation of a recommendation (EXPLANATION) or restriction of processing (RESTRICTION). Answered by a person within one month (`dueAt`).
         * @summary File a data-subject request (GDPR Arts. 16, 21, 22)
         * @param {GDPRPrivacyApiCreateRequestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRequest(requestParameters: GDPRPrivacyApiCreateRequestRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataSubjectRequestResponse> {
            return localVarFp.createRequest(requestParameters.dataSubjectRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * A participant refuses the pending required consents. The refusal is recorded, the participant is told they cannot advance in the programme, and their facilitators and the admins are notified. Returns the consents still pending.
         * @summary Decline the required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        declineRequiredConsents(options?: RawAxiosRequestConfig): AxiosPromise<Array<RequiredConsentDto>> {
            return localVarFp.declineRequiredConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Export my personal data (GDPR Art. 20)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportMyData(options?: RawAxiosRequestConfig): AxiosPromise<DataExportResponse> {
            return localVarFp.exportMyData(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get my consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyConsents(options?: RawAxiosRequestConfig): AxiosPromise<Array<ConsentResponse>> {
            return localVarFp.getMyConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get my deletion request status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyDeletionRequests(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataDeletionResponse>> {
            return localVarFp.getMyDeletionRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * 404 when it does not exist or is about someone else.
         * @summary Get one explanation of a recommendation generated about me
         * @param {GDPRPrivacyApiGetMyExplanationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyExplanation(requestParameters: GDPRPrivacyApiGetMyExplanationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AiExplanationResponse> {
            return localVarFp.getMyExplanation(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Newest first. Each says which categories of my data were used, the logic (prompt and model version) and the reasons and evidence given.
         * @summary List the explanations of recommendations generated about me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyExplanations(options?: RawAxiosRequestConfig): AxiosPromise<Array<AiExplanationResponse>> {
            return localVarFp.getMyExplanations(options).then((request) => request(axios, basePath));
        },
        /**
         * Terms / Privacy Policy not yet accepted at the version currently in force. Empty when up to date.
         * @summary Get my pending required consents
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPendingRequiredConsents(options?: RawAxiosRequestConfig): AxiosPromise<Array<RequiredConsentDto>> {
            return localVarFp.getMyPendingRequiredConsents(options).then((request) => request(axios, basePath));
        },
        /**
         * Explanation id by kind (PLAN_FOCUS, PLAN_DIAGNOSIS, PLAN_BLUEPRINT) of the AI proposal the plan was created from. Empty when the plan was not generated or is not mine.
         * @summary Get the explanation ids behind one of my development plans
         * @param {GDPRPrivacyApiGetMyPlanExplanationIdsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyPlanExplanationIds(requestParameters: GDPRPrivacyApiGetMyPlanExplanationIdsRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.getMyPlanExplanationIds(requestParameters.planId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List my data-subject requests
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyRequests(options?: RawAxiosRequestConfig): AxiosPromise<Array<DataSubjectRequestResponse>> {
            return localVarFp.getMyRequests(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record or update a consent
         * @param {GDPRPrivacyApiRecordConsentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordConsent(requestParameters: GDPRPrivacyApiRecordConsentRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentResponse> {
            return localVarFp.recordConsent(requestParameters.recordConsentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * processing: PROFILE_ASSESSMENT or RESEARCH. Takes effect immediately and is available before the required consents are accepted.
         * @summary Object to, or withdraw the objection to, AI profiling or research (GDPR Art. 21)
         * @param {GDPRPrivacyApiRecordObjectionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordObjection(requestParameters: GDPRPrivacyApiRecordObjectionRequest, options?: RawAxiosRequestConfig): AxiosPromise<ConsentResponse> {
            return localVarFp.recordObjection(requestParameters.recordObjectionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request deletion of my data (GDPR Art. 17)
         * @param {GDPRPrivacyApiRequestDeletionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestDeletion(requestParameters: GDPRPrivacyApiRequestDeletionRequest, options?: RawAxiosRequestConfig): AxiosPromise<DataDeletionResponse> {
            return localVarFp.requestDeletion(requestParameters.dataDeletionRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for cancelDeletion operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiCancelDeletionRequest
 */
export interface GDPRPrivacyApiCancelDeletionRequest {
    /**
     * 
     * @type {number}
     * @memberof GDPRPrivacyApiCancelDeletion
     */
    readonly id: number
}

/**
 * Request parameters for confirmDeletion operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiConfirmDeletionRequest
 */
export interface GDPRPrivacyApiConfirmDeletionRequest {
    /**
     * 
     * @type {string}
     * @memberof GDPRPrivacyApiConfirmDeletion
     */
    readonly token: string
}

/**
 * Request parameters for createRequest operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiCreateRequestRequest
 */
export interface GDPRPrivacyApiCreateRequestRequest {
    /**
     * 
     * @type {DataSubjectRequestDto}
     * @memberof GDPRPrivacyApiCreateRequest
     */
    readonly dataSubjectRequestDto: DataSubjectRequestDto
}

/**
 * Request parameters for getMyExplanation operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiGetMyExplanationRequest
 */
export interface GDPRPrivacyApiGetMyExplanationRequest {
    /**
     * 
     * @type {number}
     * @memberof GDPRPrivacyApiGetMyExplanation
     */
    readonly id: number
}

/**
 * Request parameters for getMyPlanExplanationIds operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiGetMyPlanExplanationIdsRequest
 */
export interface GDPRPrivacyApiGetMyPlanExplanationIdsRequest {
    /**
     * 
     * @type {number}
     * @memberof GDPRPrivacyApiGetMyPlanExplanationIds
     */
    readonly planId: number
}

/**
 * Request parameters for recordConsent operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiRecordConsentRequest
 */
export interface GDPRPrivacyApiRecordConsentRequest {
    /**
     * 
     * @type {RecordConsentRequest}
     * @memberof GDPRPrivacyApiRecordConsent
     */
    readonly recordConsentRequest: RecordConsentRequest
}

/**
 * Request parameters for recordObjection operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiRecordObjectionRequest
 */
export interface GDPRPrivacyApiRecordObjectionRequest {
    /**
     * 
     * @type {RecordObjectionRequest}
     * @memberof GDPRPrivacyApiRecordObjection
     */
    readonly recordObjectionRequest: RecordObjectionRequest
}

/**
 * Request parameters for requestDeletion operation in GDPRPrivacyApi.
 * @export
 * @interface GDPRPrivacyApiRequestDeletionRequest
 */
export interface GDPRPrivacyApiRequestDeletionRequest {
    /**
     * 
     * @type {DataDeletionRequestDto}
     * @memberof GDPRPrivacyApiRequestDeletion
     */
    readonly dataDeletionRequestDto: DataDeletionRequestDto
}

/**
 * GDPRPrivacyApi - object-oriented interface
 * @export
 * @class GDPRPrivacyApi
 * @extends {BaseAPI}
 */
export class GDPRPrivacyApi extends BaseAPI {
    /**
     * Accepts the current version of every pending required consent (Terms, Privacy Policy), recording IP address, User-Agent and timestamp. Returns the consents still pending (normally empty).
     * @summary Accept all required consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public acceptRequiredConsents(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).acceptRequiredConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only while still awaiting confirmation or within the grace period.
     * @summary Cancel my deletion request
     * @param {GDPRPrivacyApiCancelDeletionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public cancelDeletion(requestParameters: GDPRPrivacyApiCancelDeletionRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).cancelDeletion(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Public: the token itself is the authenticator, matching the password-reset confirm flow. Starts the grace period before the deletion is actually executed.
     * @summary Confirm a data deletion request via its emailed token
     * @param {GDPRPrivacyApiConfirmDeletionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public confirmDeletion(requestParameters: GDPRPrivacyApiConfirmDeletionRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).confirmDeletion(requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Human review of an automated result (AI_REVIEW), rectification of data the user cannot edit (RECTIFICATION, requires rectificationField), objection (OBJECTION), an explanation of a recommendation (EXPLANATION) or restriction of processing (RESTRICTION). Answered by a person within one month (`dueAt`).
     * @summary File a data-subject request (GDPR Arts. 16, 21, 22)
     * @param {GDPRPrivacyApiCreateRequestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public createRequest(requestParameters: GDPRPrivacyApiCreateRequestRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).createRequest(requestParameters.dataSubjectRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * A participant refuses the pending required consents. The refusal is recorded, the participant is told they cannot advance in the programme, and their facilitators and the admins are notified. Returns the consents still pending.
     * @summary Decline the required consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public declineRequiredConsents(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).declineRequiredConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Export my personal data (GDPR Art. 20)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public exportMyData(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).exportMyData(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get my consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyConsents(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get my deletion request status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyDeletionRequests(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyDeletionRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 404 when it does not exist or is about someone else.
     * @summary Get one explanation of a recommendation generated about me
     * @param {GDPRPrivacyApiGetMyExplanationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyExplanation(requestParameters: GDPRPrivacyApiGetMyExplanationRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyExplanation(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Newest first. Each says which categories of my data were used, the logic (prompt and model version) and the reasons and evidence given.
     * @summary List the explanations of recommendations generated about me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyExplanations(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyExplanations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Terms / Privacy Policy not yet accepted at the version currently in force. Empty when up to date.
     * @summary Get my pending required consents
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyPendingRequiredConsents(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyPendingRequiredConsents(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Explanation id by kind (PLAN_FOCUS, PLAN_DIAGNOSIS, PLAN_BLUEPRINT) of the AI proposal the plan was created from. Empty when the plan was not generated or is not mine.
     * @summary Get the explanation ids behind one of my development plans
     * @param {GDPRPrivacyApiGetMyPlanExplanationIdsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyPlanExplanationIds(requestParameters: GDPRPrivacyApiGetMyPlanExplanationIdsRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyPlanExplanationIds(requestParameters.planId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List my data-subject requests
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public getMyRequests(options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).getMyRequests(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record or update a consent
     * @param {GDPRPrivacyApiRecordConsentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public recordConsent(requestParameters: GDPRPrivacyApiRecordConsentRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).recordConsent(requestParameters.recordConsentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * processing: PROFILE_ASSESSMENT or RESEARCH. Takes effect immediately and is available before the required consents are accepted.
     * @summary Object to, or withdraw the objection to, AI profiling or research (GDPR Art. 21)
     * @param {GDPRPrivacyApiRecordObjectionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public recordObjection(requestParameters: GDPRPrivacyApiRecordObjectionRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).recordObjection(requestParameters.recordObjectionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request deletion of my data (GDPR Art. 17)
     * @param {GDPRPrivacyApiRequestDeletionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GDPRPrivacyApi
     */
    public requestDeletion(requestParameters: GDPRPrivacyApiRequestDeletionRequest, options?: RawAxiosRequestConfig) {
        return GDPRPrivacyApiFp(this.configuration).requestDeletion(requestParameters.dataDeletionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

